import {
  IDataGridDefinition,
  IDataGridSource,
  IComboList,
  FormType,
} from "@siu/shared";
import { ISolicitud } from "src/app/modules/autorizaciones/interfaces/autorizacion.interface";

export interface IFormBuscarSolicitudes {
  eIdTipoAutorizacion: number;
  FK_eIdSolicitudEstado: number;
  fFechaSolicitud: any;
  fFechaSolicitudDesde: any;
  fFechaSolicitudHasta: any;
  cUbigeoOrigen: string;
  cUbigeoDestino: string;
  eIdEmpresa: number;
}

export interface IFormularioBuscarSolicitud {
  isLoading: boolean;
  error: any;
  definition: IDataGridDefinition;
  gridSource: IDataGridSource<ISolicitud>;
  type: FormType;
  solicitud: ISolicitud;
  modalAutorizacionConsulta: IModalAutorizacionConsulta;
  modalCronogramaConsulta: IModalCronogramaConsulta;
  modalSubsanadoConsulta: IModalSubsanadoConsulta;
  modalCargoAutorizacionConsulta: IModalCargoAutorizacionConsulta;
  formBuscar: IFormBuscarSolicitudes;
  filterLists: {
    tipoAutorizacion: IComboList;
    estados: IComboList;
    listDepartamentoOrigen: IComboList;
    listProvinciaOrigen: IComboList;
    listDistritoOrigen: IComboList;
    listDepartamentoDestino: IComboList;
    listProvinciaDestino: IComboList;
    listDistritoDestino: IComboList;
  };
}

//MODAL CONSULTA
export interface IModalAutorizacionConsulta {
  title: string;
  isLoading: boolean;
  error: any;
  type: FormType;

  idSolicitud: number;
  solicitud: any;
}

export interface IModalCronogramaConsulta {
  title: string;
  isLoading: boolean;
  error: any;
  type: FormType;

  idSolicitud: number;
  idDocumento: number;
  solicitud: any;
  cronograma: number;
}

export interface IModalSubsanadoConsulta {
  title: string;
  isLoading: boolean;
  error: any;
  type: FormType;

  idSolicitud: number;
  idDocumento: number;
  solicitud: any;
  subsanado: number;
}

export interface IModalCargoAutorizacionConsulta {
  title: string;
  isLoading: boolean;
  error: any;
  type: FormType;
  solicitudSeleccionada: any;
}

export enum EstadoSolicitudEnum {
  EN_PROCESO = 1,
  OBSERVADO = 2,
  APROBADO = 3,
  NO_PRESENTADO = 4,
  ENVIADO = 5,
  OBSERVADO_SUBSANADO = 6,
  RECONSIDERACION_EN_PROCESO = 7,
  RECHAZADO_SUBSANACION = 8,
  APROBADO_SUBSANACION = 9,
  APROBADO_RECONSIDERACION = 10,
  RECHAZADO_RECONSIDERACION = 11,
  APELACION_EN_PROCESO = 12,
  APROBADO_APELACION = 13,
  RECHAZADO_APELACION = 14,
}
